export function createSudsConfig() {
	return {
		trackerKind: "sudsSeries",
		title: "Subjective Units of Distress Scale (SUDS)",
		instructions: "Rate how distressed you feel right now during this exposure.",
		question: "What is your SUDS rating right now?",
		contextLabel: "Exposure target or situation",
		labels: {
			moment: "Moment / time",
			rating: "Reported SUDS",
			missed: "Missed",
			corrected: "Corrected",
			interrupted: "Exposure interrupted",
			inProgress: "Exposure in progress",
			completed: "Completed",
			first: "First recorded",
			peak: "Peak",
			minimum: "Minimum",
			last: "Last recorded",
			change: "Observed-point change",
			history: "Earlier practice",
		},
		ratingScaleMin: 0,
		ratingScaleMax: 100,
		anchors: [
			{id: "none", value: 0, title: "No distress; calm and relaxed"},
			{id: "mild", value: 25, title: "Mild distress"},
			{id: "moderate", value: 50, title: "Moderate distress"},
			{id: "marked", value: 75, title: "Marked distress"},
			{id: "highest", value: 100, title: "Highest distress or anxiety experienced"},
		],
		points: [
			{id: "before", title: "Before", instructions: "Before the exposure"},
			{id: "during", title: "During", instructions: "During the exposure"},
			{id: "after", title: "After", instructions: "After the exposure"},
		],
		archivedPoints: [],
	}
}

export function createSudsDemoPayload() {
	return {series: [{id: "practice", target: "Touching the office door handle", status: "inProgress", ratings: [
		{id: "baseline", pointId: "before", value: 20, recordedAt: "2026-10-29T10:00:00.000Z"},
		{id: "peak", pointId: "during", value: 70, recordedAt: "2026-10-29T10:05:00.000Z"},
		{id: "end", pointId: "after", value: 35, recordedAt: "2026-10-29T10:10:00.000Z"},
	]}]}
}
